<footer class="footer">
  <div class="d-sm-flex justify-content-center justify-content-sm-between py-2">
    <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Design by <a href="https://iloka.vn">iloka.vn</a></span>
    <!-- <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Free <a href="https://www.bootstrapdash.com/angular-admin-templates/" target="_blank">  angular admin template </a> from <a href="https://www.bootstrapdash.com/" target="_blank">bootstrapdash.com </a></span> -->
  </div>
</footer>